// extracted by mini-css-extract-plugin
export var hidden = "_nz-1";
export var visible = "_nz-0";